import React, { Component } from "react";
import { connect } from "react-redux";
import { Accordion, Table } from "semantic-ui-react";
import { parseString } from "xml2js";
import _ from "lodash";
import api from "../../api";
import settings from "../../settings";
import addVehicleInfoRows from "./VehicleInfo";

class MotorVehicleReportSection extends Component {
  constructor(props) {
    super(props);
    const { internalID, savedResultID } = props.additionalData;
    this.state = {
      activeIndex: 0,
      rows: [],
      savedResultID,
      internalID,
    };
  }

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadSection = (node, props) => {
    const rows = [];
    const records = _.get(
      node,
      "personReport.mvraddons[0].motorVehicleSearch2Response[0].records[0].record"
    );
    let vehCount = 0;
    if (records !== undefined) {
      const prevVehRecIds = [];
      _.forEach(records, (record, index) => {
        const curVehRecId = _.get(
          record,
          "vehicleInfo[0].vehicleRecordId[0]._"
        );
        if (!prevVehRecIds.includes(curVehRecId)) {
          addVehicleInfoRows(props, record, rows, index, true);
          vehCount += 1;
          prevVehRecIds.push(curVehRecId);
        }
      });
      this.setState({ rows });
      props.updateItemCountBySection(props.sectionName, vehCount);
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
      this.setState({ rows });
      props.updateItemCountBySection(props.sectionName, vehCount);
    }
  };

  loadData = (props) => {
    const sectionNode = _.get(props.reportData, "personReport.mvraddons[0]");
    if (sectionNode) {
      this.loadSection(props.reportData, props);
    } else {
      const additionalData = _.cloneDeep(props.additionalData);
      additionalData.requestedSection = "mvraddon";
      api.report
        .person(additionalData)
        .then((res) => {
          parseString(res.data, { async: false }, (err, rslt) => {
            this.loadSection(rslt, props);
          });
        })
        .catch((err) => console.log("email res error - ", err));
    }
  };

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    return (
      <Accordion fluid styled id={`nav_${this.props.sectionName}`}>
        <Accordion.Title
          active={this.state.activeIndex === 0}
          className="report-section-header"
          key={`MotorVehicle_Title`}
          onClick={() => this.handleClick()}
        >
          <p>
            Motor Vehicles
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`MotorVehicle_Body`}
          active={this.state.activeIndex === 0}
        >
          {this.state.rows.length < 1 ? (
            <span>No Records Found</span>
          ) : (
            <Table>
              <Table.Body>
                <Table.Row>
                  <Table.Cell colSpan={4}>
                    <span>
                      I agree that I, and the organization I represent if
                      applicable, will NOT use the information accessed through
                      this search in whole or in part for the purpose of serving
                      as a factor in establishing a consumer’s eligibility for
                      CREDIT or INSURANCE, EMPLOYMENT purposes, or for any other
                      purpose(s) authorized under section 604 of the Federal
                      Fair Credit Reporting Act (15 U.S.C. Sec. 1681 et seq.)
                      (‘FCRA’) Driver Privacy Protection Act (‘DPPA’) and
                      Gramm–Leach–Bliley Act (‘GLBA’). {settings.appName} is not
                      a consumer reporting agency and {settings.appName} reports
                      do not constitute consumer reports as such terms are
                      defined in the FCRA, DPPA and GLBA and accordingly these
                      reports may not be used for purposes provided for in the
                      FCRA. As this information is compiled from individual
                      sources, {settings.appName} does not guarantee the
                      comprehensiveness or accuracy of these records, nor that
                      they are a complete history of activity.
                    </span>
                  </Table.Cell>
                </Table.Row>
                {this.state.rows}
              </Table.Body>
            </Table>
          )}
        </Accordion.Content>
      </Accordion>
    );
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount };
}

export default connect(mapStateToProps, null)(MotorVehicleReportSection);



// WEBPACK FOOTER //
// ./src/components/reports/MotorVehicleReportSection.js